import { safeStorage } from "./storage";

// First-touch campaign data, captured at boot from whatever URL the visitor
// landed on. Instagram ads land on /signup or /start with utm_* and fbclid, and
// both are gone after the first navigation, so they have to be read before the
// router moves anywhere. The first capture wins: a later visit from a reminder
// email must not overwrite the campaign that brought the person in.

export const ATTRIBUTION_KEY = "attribution";

const CAMPAIGN_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
  "ttclid",
];

const MAX_LENGTH = 255;

export function readCampaignParams(search) {
  const params = new URLSearchParams(search || "");
  const found = {};
  for (const key of CAMPAIGN_PARAMS) {
    const value = params.get(key);
    if (value) found[key] = value.slice(0, MAX_LENGTH);
  }
  return found;
}

export function captureAttribution(location = globalThis.location, referrer) {
  if (!location) return null;
  const existing = getAttribution();
  if (existing) return existing;

  const campaign = readCampaignParams(location.search);
  const ref = referrer ?? (typeof document !== "undefined" ? document.referrer : "");
  const attribution = {
    ...campaign,
    landing_path: (location.pathname || "").slice(0, MAX_LENGTH),
    referrer: (ref || "").slice(0, MAX_LENGTH),
    captured_at: new Date().toISOString(),
  };
  safeStorage.set(ATTRIBUTION_KEY, attribution);
  return attribution;
}

export function getAttribution() {
  const value = safeStorage.get(ATTRIBUTION_KEY);
  return value && typeof value === "object" ? value : null;
}
